import React, { useRef } from "react";
import styled from "styled-components";
import { motion, useInView } from "framer-motion";

const faceServices = [
  {
    num: "01",
    title: "Deep Cleansing",
    subtitle: "Pastrim i Thellë Profesional",
    desc: "Trajtim esencial për pastrimin e lëkurës në thellësi. Heq papastërtitë, pikat e zeza dhe yndyrën e tepërt, duke ndihmuar në rifreskimin dhe shëndetin e lëkurës. Lëkura mbetet më e pastër, më e butë dhe me pamje më të shëndetshme.",
    tag: "Më i Popullarit",
  },
  {
    num: "02",
    title: "HydraFacial",
    subtitle: "Pastrim · Eksfolim · Hidratim",
    desc: "Trajtim modern që kombinon pastrimin, eksfolimin, ekstraktimin dhe hidratimin e thellë të lëkurës. Jep shkëlqim të menjëhershëm, përmirëson teksturën dhe ndihmon në reduktimin e poreve të zmadhuara dhe dehidrimit.",
    tag: "Signature",
  },
  {
    num: "03",
    title: "Dermapen (Microneedling)",
    subtitle: "Stimulim i Kolagjenit",
    desc: "Trajtim inovativ që stimulon prodhimin e kolagjenit përmes mikro-gjilpërave të kontrolluara. Efektiv për shenjat e akneve, rrudhat e imta, njollat dhe për përmirësimin e strukturës së përgjithshme të lëkurës.",
    tag: null,
  },
  {
    num: "04",
    title: "Chemical Peel",
    subtitle: "Rigjenerim i Lëkurës",
    desc: "Trajtim eksfoliues me acide të kontrolluara që largon shtresën e vjetër të lëkurës. Ndihmon në trajtimin e akneve, njollave dhe rigjenerimin e lëkurës për një pamje më të ndritshme dhe uniforme.",
    tag: null,
  },
];

const bodyServices = [
  {
    num: "05",
    title: "Ultra Contour Touch Vecom",
    subtitle: "Konturim & Dobësim i Trupit",
    desc: "Trajtim efektiv për dobësim dhe konturim të trupit që ndihmon në reduktimin e yndyrës së lokalizuar dhe tonifikimin e lëkurës, duke formësuar siluetën në mënyrë të dukshme.",
    tag: null,
  },
  {
    num: "06",
    title: "Body Combo 10 Vecom",
    subtitle: "Program Intensiv Dobësimi",
    desc: "Program i kombinuar trajtimesh për dobësim intensiv që ndihmon në reduktimin e centimetrave, djegien e yndyrës dhe përmirësimin e tonusit të trupit për rezultate më të shpejta dhe të qëndrueshme.",
    tag: "Paketë",
  },
  {
    num: "07",
    title: "Maderoterapia",
    subtitle: "Masazh Terapeutik me Dru",
    desc: "Masazh terapeutik me mjete druri që stimulon qarkullimin limfatik, ndihmon në reduktimin e celulitit dhe përmirëson tonifikimin e lëkurës në mënyrë natyrale.",
    tag: null,
  },
  {
    num: "08",
    title: "VF 100",
    subtitle: "Vakum & Frekuencë",
    desc: "Trajtim me teknologji vakumi dhe frekuence që ndihmon në përmirësimin e qarkullimit, reduktimin e celulitit dhe tonifikimin e zonave problematike të trupit.",
    tag: "I Ri",
  },
];

const cardVariants = {
  hidden: { y: 60, opacity: 0 },
  visible: (i) => ({
    y: 0,
    opacity: 1,
    transition: { duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] },
  }),
};

const ServiceGroup = ({ services, startInView }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <Grid ref={ref}>
      {services.map((s, i) => (
        <Card
          key={s.num}
          as={motion.div}
          custom={i}
          variants={cardVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          whileHover={{ y: -8, transition: { duration: 0.3 } }}
        >
          {s.tag && <Tag>{s.tag}</Tag>}
          <Num>{s.num}</Num>
          <CardTitle>{s.title}</CardTitle>
          <CardSub>{s.subtitle}</CardSub>
          <Divider />
          <CardDesc>{s.desc}</CardDesc>
          <CardLink href="#contact">
            Rezervo trajtimin <span>→</span>
          </CardLink>
        </Card>
      ))}
    </Grid>
  );
};

const Services = () => {
  return (
    <Section id="services">
      <Inner>
        {/* Header */}
        <Header>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <Label>Çfarë Ofrojmë</Label>
          </motion.div>
          <TitleRow>
            <motion.div
              initial={{ opacity: 0, x: -60 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            >
              <SectionTitle>
                Our
                <br />
                <em>Services</em>
              </SectionTitle>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 60 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 1,
                delay: 0.15,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              <SectionDesc>
                Çdo trajtim në Elaia është një eksperiencë unike — protokolle
                precize të dizajnuara për lëkurën dhe rezultatet tuaja.
              </SectionDesc>
            </motion.div>
          </TitleRow>
        </Header>

        {/* Face group */}
        <GroupBlock>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <GroupLabel>
              <GroupLine />
              Face Treatments
              <GroupLine />
            </GroupLabel>
          </motion.div>
          <ServiceGroup services={faceServices} />
        </GroupBlock>

        {/* Body group */}
        <GroupBlock>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
          >
            <GroupLabel>
              <GroupLine />
              Body Treatments
              <GroupLine />
            </GroupLabel>
          </motion.div>
          <ServiceGroup services={bodyServices} />
        </GroupBlock>
      </Inner>
    </Section>
  );
};

/* ── Styles ── */

const Section = styled.section`
  background: var(--charcoal);
  padding: 140px 0;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 60px;
    right: 60px;
    height: 1px;
    background: linear-gradient(
      to right,
      transparent,
      rgba(196, 149, 122, 0.25),
      transparent
    );
  }
`;

const Inner = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 60px;
  @media (max-width: 768px) {
    padding: 0 24px;
  }
`;

const Header = styled.div`
  margin-bottom: 80px;
`;

const Label = styled.span`
  display: block;
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: var(--rose);
  margin-bottom: 20px;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 40px;
  flex-wrap: wrap;
`;

const SectionTitle = styled.h2`
  font-family: var(--font-display);
  font-size: clamp(48px, 6vw, 88px);
  font-weight: 300;
  color: var(--cream);
  letter-spacing: -0.02em;
  line-height: 1.05;
  margin: 0;
  em {
    font-style: italic;
    color: var(--rose);
  }
`;

const SectionDesc = styled.p`
  max-width: 380px;
  font-family: var(--font-body);
  font-size: 15px;
  color: var(--taupe);
  line-height: 1.8;
  font-weight: 300;
`;

const GroupBlock = styled.div`
  margin-bottom: 80px;
  &:last-child {
    margin-bottom: 0;
  }
`;

const GroupLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  font-family: var(--font-body);
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.3em;
  text-transform: uppercase;
  color: var(--cream);
  opacity: 0.4;
  margin-bottom: 28px;
`;

const GroupLine = styled.span`
  flex: 1;
  height: 1px;
  background: rgba(196, 149, 122, 0.2);
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2px;
  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  position: relative;
  background: rgba(196, 186, 179, 0.06);
  border: 1px solid rgba(196, 149, 122, 0.08);
  padding: 44px 36px;
  cursor: pointer;
  overflow: hidden;
  transition:
    background 0.4s,
    border-color 0.4s;
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 2px;
    background: var(--rose);
    transition: width 0.5s cubic-bezier(0.22, 1, 0.36, 1);
  }
  &:hover::after {
    width: 100%;
  }
  &:hover {
    background: rgba(196, 149, 122, 0.05);
    border-color: rgba(196, 149, 122, 0.2);
  }
  @media (max-width: 768px) {
    padding: 36px 24px;
  }
`;

const Tag = styled.span`
  display: inline-block;
  font-family: var(--font-body);
  font-size: 9px;
  font-weight: 500;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: var(--charcoal);
  background: var(--rose);
  padding: 4px 12px;
  margin-bottom: 20px;
`;

const Num = styled.span`
  display: block;
  font-family: var(--font-display);
  font-size: 12px;
  color: rgba(196, 149, 122, 0.35);
  letter-spacing: 0.1em;
  margin-bottom: 14px;
`;

const CardTitle = styled.h3`
  font-family: var(--font-display);
  font-size: clamp(20px, 2vw, 26px);
  font-weight: 400;
  color: var(--cream);
  letter-spacing: -0.01em;
  margin: 0 0 6px;
  line-height: 1.15;
`;

const CardSub = styled.p`
  font-family: var(--font-body);
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--rose);
  margin: 0;
`;

const Divider = styled.div`
  width: 28px;
  height: 1px;
  background: rgba(196, 149, 122, 0.3);
  margin: 20px 0;
`;

const CardDesc = styled.p`
  font-family: var(--font-body);
  font-size: 13px;
  font-weight: 300;
  color: var(--taupe);
  line-height: 1.8;
  margin: 0 0 24px;
`;

const CardLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  font-family: var(--font-body);
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--cream);
  opacity: 0.5;
  transition:
    opacity 0.3s,
    color 0.3s;
  span {
    transition: transform 0.3s;
  }
  &:hover {
    opacity: 1;
    color: var(--rose);
  }
  &:hover span {
    transform: translateX(6px);
  }
`;

export default Services;
